module.exports = __webpack_public_path__ + "static/media/39_A.e8e7e97b.png";